import React from 'react';
import PropTypes from 'prop-types';
import { Toggle, ContainerToggle, TextToggle } from '@playbookux/playbook-web-core';

import {
  Container,
  ContainerTitle,
  IconTitle,
  Title,
  QuestionIndex,
} from './styles';

import AddQuestions from './add-question';

const Multiple = (props) => {
  const {
    question,
    index,
    errors,
    touched,
    isEdit,
    taskIndex,
    testType,
    setFieldValue,
  } = props;

  let fieldName = testType === 'survey' ? `surveysPages[${taskIndex}].tasks[${index}].randomize` : `tasks.${index}.randomize`;

  if (testType === 'tree_test') fieldName = `tasks.${taskIndex}.tasks.${index}.randomize`;

  const toggleRandomize = () => {
    setFieldValue(fieldName, !question.randomize, false);
  };

  return (
    <Container>
      <ContainerTitle>
        <QuestionIndex>{index + 1}</QuestionIndex>
        <IconTitle src="/images/question-multiple.png" />
        <Title color="questionTitleMultiple">
          Multiple Selection (pick any)
        </Title>

      </ContainerTitle>

      <AddQuestions
        question={question}
        index={index}
        errors={errors}
        touched={touched}
        isEdit={isEdit}
        taskIndex={taskIndex}
        testType={testType}
      />

      <ContainerToggle>
        <Toggle
          onChange={toggleRandomize}
          checked={question.randomize}
          disabled={isEdit}
          id={question.id}
          name="randomize"
        />
        <TextToggle fontSize={12}>Randomize answer choices</TextToggle>
      </ContainerToggle>
    </Container>
  );
};

Multiple.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.string.isRequired,
    questionOptions: PropTypes.array,
    randomize: PropTypes.bool,
  }).isRequired,
  index: PropTypes.number.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  isEdit: PropTypes.bool.isRequired,
  taskIndex: PropTypes.number,
  testType: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

Multiple.defaultProps = {
  taskIndex: null,
};

export default Multiple;
